import { useLocation, useNavigate } from "react-router-dom";
import Cookie from "../cookies/Cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMe, meState } from "../../../web/models/users/Index";
import MembresiaBar from "../perfil/MembresiaBar";
import { Logout } from "../../../utils/Logout";
import EntradasBar from "../perfil/EntradasBar";
import OfHeader from "./OfHeader";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import WhatsAppButton from "../ui/WhatsAppButton";

const Header = ({ discount }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const getParams = new URLSearchParams(location.search);
  const _me = useSelector(meState);
  const me = _me.me;
  const navigate = useNavigate();
  const bar = [
    {
      name: "Inicio",
      link: "/inicio",
      dropdown: null,
      show: true,
    },
    {
      name: "Entradas",
      link: "/entradas",
      dropdown: null,
      show: true,
    },
    {
      name: "Festival Nevadas",
      link: "/festivales",
      dropdown: null,
      show: true,
    },
    {
      name: "Contenidos",
      link: "#",
      show: true,
      dropdown: [
        {
          name: "Notas",
          link: "/contenidos/notas",
        },
        {
          name: "Videos",
          link: "/contenidos/videos",
        },
      ],
    },
    {
      name: "Salas",
      link: "/salas",
      dropdown: null,
      show: true,
    },
    {
      name: "Festivales",
      link: "/festivales",
      dropdown: null,
      show: false,
    },
    {
      name: "Descuentos",
      link: "/descuentos",
      dropdown: null,
      show: discount,
    },
  ];

  const [geolocation, setGeolocation] = useState(
    localStorage.getItem("geolocation") ?? 'Todos'
  );
  const [provincias, setProvincias] = useState(null);
  const [search, setSearch] = useState("");

  const fetch = async (setData, params, url) => {
    const response = await apiPrivateAntesala.get(url, { params });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  const onClick = (e) => {
    switch (e.target.name) {
      case "search":
        {
          return (window.location.href = `/entradas?search=${search}`);
        }
        break;
      case "login":
        {
          return navigate(`/login`);
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (!me) {
      let params = {
        url: "/auth/me",
      };
      dispatch(fetchMe(params));
    }
  }, []);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  useEffect(() => {
    const ofEntradas = () => {
      document.getElementById("of-entradas")?.click();
    };
    if (getParams.get("ofEntradas") && me) {
      ofEntradas();
    }

    if (getParams.get("provincia")) {
      setGeolocation(getParams.get("provincia"))
    }
  }, [me]);
  return (
    <>
      <div className="sticky-top bg-white shadow-sm" style={{ zIndex: 1020 }}>
        <div className="container-md">
          <nav className="navbar navbar-expand-lg bg-white py-3">
            <div className="container-fluid px-0">
              <div className="d-flex align-items-center gap-3">
                <a className="navbar-brand m-0" href="/">
                  <img
                    src="/assets/img/marca/antesala-logo.svg"
                    width="60px"
                    height="auto"
                    className="d-block d-md-none"
                    alt="Antesala"
                  />
                  <img
                    src="/assets/img/marca/antesala-logo.svg"
                    width="120px"
                    height="auto"
                    className="d-none d-md-block"
                    alt="Antesala"
                  />
                </a>
                <button
                  className="d-md-none btn btn-sm btn-outline-secondary d-flex justify-content-between align-items-center gap-2"
                  style={{ borderRadius: "20px", fontSize: '12px', padding: '6px 12px' }}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasTop-header-geolocation"
                  aria-controls="offcanvasTop-header-geolocation"
                  type="button"
                >
                  <i className="bi bi-geo-alt-fill"></i>
                  <span className="text-truncate" style={{ maxWidth: '70px' }}>{geolocation}</span>
                  <i className="bi bi-chevron-down" style={{ fontSize: '10px' }}></i>
                </button>
              </div>
              <button
                className="navbar-toggler border-0 shadow-sm"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasTop-header"
                aria-controls="offcanvasTop-header"
                style={{ borderRadius: '10px' }}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse border-0"
                id="navbarSupportedContent"
              >
                <div className="row w-100 align-items-center">
                  <div className="col-lg-6">
                    <ul className="navbar-nav justify-content-start align-items-center mb-2 mb-lg-0 gap-1">
                      {bar.map((menu, idx) => {
                        if (menu.dropdown) {
                          return (
                            <li
                              key={idx}
                              className={`nav-item dropdown ${menu.show ? "" : "d-none"}`}
                            >
                              <a
                                className="dropdown-toggle px-3 py-2 rounded-3 text-dark fw-semibold position-relative"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                href="#"
                                style={{
                                  fontSize: '15px',
                                  transition: 'all 0.2s ease',
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                              >
                                {menu.name}
                              </a>
                              <ul className="dropdown-menu border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                                {menu.dropdown.map((submenu, subIdx) => {
                                  return (
                                    <li key={subIdx}>
                                      <a
                                        className="dropdown-item py-2 px-3 text-dark"
                                        href={submenu.link}
                                        style={{
                                          fontSize: '14px',
                                          transition: 'all 0.2s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.backgroundColor = '#f8f9fa';
                                          e.target.style.paddingLeft = '20px';
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.backgroundColor = 'transparent';
                                          e.target.style.paddingLeft = '12px';
                                        }}
                                      >
                                        <i className="bi bi-arrow-right-short me-2"></i>
                                        {submenu.name}
                                      </a>
                                    </li>
                                  );
                                })}
                              </ul>
                            </li>
                          );
                        } else {
                          return (
                            <li
                              key={idx}
                              className={`nav-item ${menu.show ? "" : "d-none"}`}
                            >
                              <a
                                className="text-dark  px-3 py-2 rounded-3 text-dark fw-semibold"
                                aria-current="page"
                                href={menu.link}
                                style={{
                                  fontSize: '15px',
                                  transition: 'all 0.2s ease',
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                              >
                                {menu.name}
                              </a>
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>

                  <div className="col-lg-6">
                    <div className="d-flex justify-content-end align-items-center gap-2">
                      {/* Search Bar */}
                      <div className="input-group" style={{ maxWidth: '300px' }}>
                        <input
                          className="form-control border border-secondary"
                          style={{ borderRadius: "20px 0 0 20px", fontSize: '14px' }}
                          type="search"
                          placeholder="Buscar eventos..."
                          onChange={(e) => setSearch(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter")
                              onClick({ target: { name: "search" } });
                          }}
                        />
                        <button
                          className="btn btn-dark border-0"
                          style={{ borderRadius: "0 20px 20px 0" }}
                          name="search"
                          onClick={(e) => onClick(e)}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                      </div>

                      {/* Geolocation Dropdown */}
                      <div className="dropdown">
                        <button
                          className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center gap-2"
                          style={{ borderRadius: "20px", fontSize: '14px', whiteSpace: 'nowrap' }}
                          type="button"
                          id="dropdownGeolocation"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bi bi-geo-alt-fill"></i>
                          <span className="d-none d-lg-inline">{geolocation}</span>
                        </button>
                        <ul
                          className="dropdown-menu border-0 shadow-sm"
                          aria-labelledby="dropdownGeolocation"
                          style={{
                            borderRadius: '12px',
                            maxHeight: '400px',
                            overflowY: 'auto'
                          }}
                        >
                          <li className="px-3 py-2 text-muted small border-bottom">
                            <i className="bi bi-geo-alt me-2"></i>
                            Selecciona tu provincia
                          </li>
                          {/* Opción "Todos" */}
                          <li>
                            <button
                              className="dropdown-item py-2"
                              style={{
                                transition: 'all 0.2s ease',
                                fontSize: '14px',
                                fontWeight: geolocation === 'Todos' ? 'bold' : 'normal'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.paddingLeft = '20px';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.paddingLeft = '12px';
                              }}
                              onClick={() => {
                                localStorage.setItem("geolocation", "Todos");
                                getParams.delete('provincia');
                                navigate(`?${getParams.toString()}`);
                                setGeolocation("Todos");
                                return window.location.reload();
                              }}
                            >
                              {geolocation === 'Todos' && (
                                <i className="bi bi-check-circle-fill text-success me-2"></i>
                              )}
                              Todos
                            </button>
                          </li>
                          <li><hr className="dropdown-divider my-1" /></li>
                          {provincias
                            ? provincias.map((provincia, idx) => (
                              <li key={idx}>
                                <button
                                  className="dropdown-item py-2"
                                  style={{
                                    transition: 'all 0.2s ease',
                                    fontSize: '14px'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f8f9fa';
                                    e.target.style.paddingLeft = '20px';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.paddingLeft = '12px';
                                  }}
                                  onClick={() => {
                                    localStorage.setItem(
                                      "geolocation",
                                      provincia.provincia
                                    );
                                    getParams.set('provincia', provincia.provincia);
                                    navigate(`?${getParams.toString()}`);
                                    setGeolocation(provincia.provincia);
                                    return window.location.reload();
                                  }}
                                >
                                  {geolocation === provincia.provincia && (
                                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                                  )}
                                  {provincia.provincia}
                                </button>
                              </li>
                            ))
                            : ""}
                        </ul>
                      </div>

                      {/* User Menu */}
                      {me ? (
                        <div className="dropdown">
                          <button
                            className="btn btn-outline-dark d-flex align-items-center gap-2"
                            style={{ borderRadius: "20px", fontSize: '14px' }}
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <span className="d-none d-lg-inline">{`${me.nombre}`}</span>
                            <i className="bi bi-chevron-down" style={{ fontSize: '10px' }}></i>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm" style={{ borderRadius: '12px', minWidth: '220px' }}>
                            <li className="px-3 py-2 border-bottom">
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="rounded-circle bg-naranja text-white d-flex align-items-center justify-content-center"
                                  style={{ width: '40px', height: '40px', fontSize: '16px', fontWeight: 'bold' }}
                                >
                                  {me.nombre?.charAt(0)}{me.apellido?.charAt(0)}
                                </div>
                                <div className="flex-grow-1">
                                  <div className="fw-semibold small">{`${me.nombre} ${me.apellido}`}</div>
                                  <div className="text-muted" style={{ fontSize: '12px' }}>{me.email}</div>
                                </div>
                              </div>
                            </li>
                            <li
                              className={`${me.roles[0].nombre == "adm" ||
                                me.roles[0].nombre == "prd" ||
                                me.roles[0].nombre == "sala"
                                ? ""
                                : "d-none"
                                }`}
                            >
                              <a
                                className="dropdown-item py-2 d-flex align-items-center gap-2"
                                href={"/dashboard/perfil"}
                                style={{ fontSize: '14px' }}
                              >
                                <i className="bi bi-speedometer2"></i>
                                Panel de Control
                              </a>
                            </li>
                            <li>
                              <button
                                className="dropdown-item py-2 d-flex align-items-center gap-2"
                                type="button"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasTop-membresia"
                                aria-controls="offcanvasTop-membresia"
                                style={{ fontSize: '14px' }}
                              >
                                <i className="bi bi-credit-card"></i>
                                Membresías
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item py-2 d-flex align-items-center gap-2"
                                type="button"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasTop-entradas"
                                aria-controls="offcanvasTop-entradas"
                                id="of-entradas"
                                style={{ fontSize: '14px' }}
                              >
                                <i className="bi bi-ticket-perforated"></i>
                                Mis Entradas
                              </button>
                            </li>
                            <li><hr className="dropdown-divider my-1" /></li>
                            <li>
                              <button
                                className="dropdown-item py-2 d-flex align-items-center gap-2 text-danger"
                                onClick={(e) => Logout()}
                                style={{ fontSize: '14px' }}
                              >
                                <i className="bi bi-box-arrow-right"></i>
                                Cerrar Sesión
                              </button>
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <button
                          className="btn btn-dark d-flex align-items-center gap-2 px-3"
                          style={{ borderRadius: "20px", fontSize: '14px' }}
                          name="login"
                          type="button"
                          onClick={(e) => onClick(e)}
                        >
                          <i className="bi bi-person-circle fs-5"
                            style={{ pointerEvents: "none" }}></i>
                          <span className="d-none d-sm-inline"
                            style={{ pointerEvents: "none" }}>Ingresar</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <MembresiaBar data={me} />
      <EntradasBar data={me} />
      <OfHeader
        bar={bar}
        me={me}
        setSearch={setSearch}
        onClick={onClick}
        provincias={provincias ?? []}
        geolocation={geolocation}
        setGeolocation={setGeolocation}
        getParams={getParams}
        navigate={navigate}
      />


      {/* Mobile Geolocation Offcanvas */}
      <div
        className="offcanvas offcanvas-bottom"
        tabIndex="-1"
        id="offcanvasTop-header-geolocation"
        aria-labelledby="offcanvasTopGeolocationLabel"
        style={{ height: '70vh', borderRadius: '20px 20px 0 0' }}
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title d-flex align-items-center gap-2" id="offcanvasTopGeolocationLabel">
            <i className="bi bi-geo-alt-fill text-primary"></i>
            Selecciona tu provincia
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="input-group mb-3">
            <span className="input-group-text bg-light border-0">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="text"
              className="form-control border-0 bg-light"
              placeholder="Buscar provincia..."
              id="search-provincia-mobile"
              onInput={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                const items = document.querySelectorAll('#provincia-list-mobile li');
                items.forEach(item => {
                  const text = item.textContent.toLowerCase();
                  item.style.display = text.includes(searchTerm) ? '' : 'none';
                });
              }}
            />
          </div>
          <ul className="list-unstyled" id="provincia-list-mobile">
            {/* Opción "Todos" */}
            <li className="mb-1">
              <button
                className={`btn w-100 text-start py-3 d-flex align-items-center justify-content-between ${geolocation === 'Todos' ? 'btn-primary text-white' : 'btn-light'
                  }`}
                style={{ borderRadius: '12px' }}
                onClick={() => {
                  localStorage.setItem("geolocation", "Todos");
                  getParams.delete('provincia');
                  navigate(`?${getParams.toString()}`);
                  setGeolocation("Todos");
                  window.location.reload();
                }}
              >
                <span className="d-flex align-items-center gap-2">
                  <i className="bi bi-globe"></i>
                  Todos
                </span>
                {geolocation === 'Todos' && (
                  <i className="bi bi-check-circle-fill"></i>
                )}
              </button>
            </li>
            {provincias ? provincias.map((provincia, index) => (
              <li key={index} className="mb-1">
                <button
                  className={`btn w-100 text-start py-3 d-flex align-items-center justify-content-between ${geolocation === provincia.provincia ? 'btn-primary text-white' : 'btn-light'
                    }`}
                  style={{ borderRadius: '12px' }}
                  onClick={() => {
                    localStorage.setItem("geolocation", provincia.provincia);
                    getParams.set('provincia', provincia.provincia);
                    navigate(`?${getParams.toString()}`);
                    setGeolocation(provincia.provincia);
                    window.location.reload();
                  }}
                >
                  <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-geo-alt"></i>
                    {provincia.provincia}
                  </span>
                  {geolocation === provincia.provincia && (
                    <i className="bi bi-check-circle-fill"></i>
                  )}
                </button>
              </li>
            )) : ""}
          </ul>
        </div>
      </div>
      <Cookie />
      <WhatsAppButton />
    </>
  );
};

export default Header;
